import type { PatientNote } from "./types";

export function toDateKey(iso: string): string {
  return iso.split("T")[0];
}

export function noteToDateKey(note: PatientNote): string {
  return note.note_date ?? toDateKey(note.created_at);
}
